export default __webpack_public_path__ + "static/media/screen_wordpress_1.b220e989.png";